var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isVanIcon ? _c("van-icon", {
    attrs: {
      name: _vm.name.substr(9),
      size: _vm.size,
      color: _vm.color
    }
  }) : _c("svg", {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true",
      width: _vm.size,
      height: _vm.size
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": _vm.symbolId,
      fill: _vm.color
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };